import React from "react";
import Modal from "./Modal";
import { Translate } from "react-redux-i18n";
import AdKindPicker from "./AdKindPicker";
import "./styles/ModalAdTypePicker.css";

function ModalAdTypePicker({ isOpen, onClose }) {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={<Translate value="ad_choose_type" />}
    >
      <div className="modal-ad-type-picker">
        <p className="modal-ad-type-picker__hint">
          <Translate value="ad_choose_type_hint" />
        </p>
        <AdKindPicker onSelect={onClose} />
      </div>
    </Modal>
  );
}

export default ModalAdTypePicker;
